<template>
    <div
        v-if="show"
        class="chat"
    >
        <div class="chat-content">
            <div   
                class="chat-content__scroll"  
                ref="list"
                @scroll="handleScroll"
            >  
                <div 
                    class="chat-list" 
                >   
                    <message-item
                        v-for="(item, index) in messages" 
                        :key="item.id"
                        :item="item"
                        :prev="messages[(index - 1) < 0 ? 0 : index - 1]"
                        @imageUploaded="imageUploaded"
                    />
                </div> 
            </div>
        </div> 

        <message-send/>

        <imageModal/>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'; 
import messageItem from '@/components/chat/messageItem/index';
import messageSend from '@/components/chat/messageSend/index';
import imageModal from '@/components/modals/image/index';

export default {
    name: 'chat', 
    components: {
        messageItem,
        messageSend,
        imageModal
    },
    computed: {
        ...mapGetters({
            messages: 'chat/messages',
            isNew: 'chat/isNew',
            show: 'chat/show'
        }), 
    },
    watch: {
        isNew(v) {  
            if (v) { 
                this.scrollToBottom();
                this.setState({
                    key: 'isNew',
                    value: false
                });
            } 
        }
    },
    methods: {
        ...mapMutations({
            setState: 'chat/setState',
            clear: 'chat/clear'
        }),
        ...mapActions({
            fetch: 'chat/fetch'
        }), 
        async handleScroll(v) { 
            const el = this.$refs['list'];
            const scrollTop = el.scrollTop; 
            const scrollHeight = el.scrollHeight;
            const offsetHeight = el.offsetHeight; 
            
            if (scrollTop == 0) { 
                await this.fetch();   
                el.scrollTop = this.$refs['list'].scrollHeight - scrollHeight; 
            } 
        },
        scrollToBottom() {   
            setTimeout(() => {
                const element = this.$refs['list'];  
                element.scrollTop = element.scrollHeight;
            }, 10);
        },
        imageUploaded() {
            this.scrollToBottom();
        }
    },
    async created() { 
        this.scrollToBottom();  
        this.setState({
            key: 'show',
            value: true
        }); 
    },
    beforeDestroy() {
        this.clear();
        this.setState({
            key: 'show',
            value: false
        });
    }
}
</script>

<style lang="scss" scoped>
.chat {
    margin-top: 24px;
    width: calc(100vw - 310px);
    height: calc(100vh - 210px);
    background-color: #fff;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.15);
    border-radius: 4px;

    &-list {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
    }

    &-content {
        width: 100%;
        height: calc(100% - 91px);  
        padding: 30px 30px 0 30px;
        display: flex; 

        &__scroll {
            height: 100%;
            overflow: scroll;
            width:100%;
        }
    }  
} 
 
@media (max-width: 768px) {
    .chat {    
        width: calc(100vw - 42px); 
        height: calc(100vh - 240px) !important;
    }
}

@media (max-width: 568px) {
    .chat {    
        width: calc(100vw - 22px); 
    }
}
</style>